import { ImageKit } from '@team/image';
import { ElementStyleOptions } from './types';

export const setupFadeOptions = (
  backgroundColor: string,
  imageHeight: number,
  amount: number
): ElementStyleOptions => {
  const fadeHeight = imageHeight * amount;
  const fadeOffset = imageHeight - fadeHeight + 10;

  return {
    image: `linear-gradient(180deg, transparent 0%, ${backgroundColor} 100%)`,
    size: `100% ${fadeHeight}px`,
    position: `0 ${fadeOffset}px`,
  };
};

export const setupImageOptions = (
  path: ImageKit.ImagePath
): ElementStyleOptions => ({
  image: `url('${path}')`,
  size: '100%',
  position: `0 0`,
});

export const setupGradientOptions = (
  gradient: string,
  imageHeight: number
): ElementStyleOptions => ({
  image: gradient,
  size: `100% ${imageHeight}px`,
  position: `0 0`,
});
